module.exports = __webpack_public_path__ + "img/02shequ.94d50161.png";